import { setApiCatalog, setExternalSystems } from "./types";

export default {
  [setExternalSystems](state: any, externalSystems: []) {
    state.externalSystems = externalSystems;
  },

  [setApiCatalog](state: any, catalog: {}) {
    state.apiCatalog = catalog;
  },
};
